import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import { DEMAND_CASES_COUNT_QUERY } from './DemandCasesCountQuery.gql';

export interface StartAutonomousSourcingDescriptionProps {
  demandId: string;
}

export const StartAutonomousSourcingDescription = ({ demandId }: StartAutonomousSourcingDescriptionProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'StartAutonomousSourcingDescription' });

  const { data } = useQuery(DEMAND_CASES_COUNT_QUERY, {
    variables: {
      id: demandId,
    },
  });

  const count = (data?.tesseract.demand?.negotiationCases.nodes ?? []).reduce((acc, item) => {
    return acc + (item.isReleasable ? 1 : 0);
  }, 0);
  const total = data?.tesseract.demand?.negotiationCases.totalCount ?? 0;

  return <>{t('label', { count, total })}</>;
};
